import { useEffect, useState } from "react";
import { IPanelUbicacionEditar } from './PanelUbicacionEditar';
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import { IUbicacionDTO } from "../../../../interfaces/ubicacion/IUbicacion";
import { LugarMovilizacionService } from "../../../../services/movilizacion/LugarMovilizacionService";

const UseUbicacionEditar = (props: IPanelUbicacionEditar) => {
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const initial: IUbicacionDTO = {
        lugarMovilizacionId: "",
        codigo: "",
        nombre: "",
        requiereTransporte: false,
        requiereVueloComercial: false,
        usuarioRegistra: "",
        estado: ""
    }
    const [command, setCommand] = useState<IUbicacionDTO>(initial)
    const [disableForm, setDisableForm] = useState<boolean>(true);

    const putEditarUbicacion = () => {
        setLoading(true)
        LugarMovilizacionService.EditarLugarMovilizacion(command).then((res) => {
            if (res.status == 200) {
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(() => {
                    props.reload?.();
                    reset()
                }, 3000)
            } else {
                setStatus(500)
            }
            setLoading(false)

        }).catch((e) => {
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
            ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);

                setTimeout(() => {
                    reset()
                }, 3000);
            } else {
                setMensaje("Error Inesperado");
            }
            setStatus(500);
            setLoading(false);
        })
    }

    const reset = () => {
        setMensaje("")
        setCommand(initial)
        setStatus(0)
        props.onDismiss()
    }


    const required: (keyof IUbicacionDTO)[] = [
        "codigo",
        "nombre"
    ];

    useEffect(() => {
        if (props.isOpen) {
            setCommand({
                ...command,
                codigo: props.ubicacionData.codigo,
                nombre: props.ubicacionData.nombre,
                requiereTransporte: props.ubicacionData.requiereTransporte,
                requiereVueloComercial: props.ubicacionData.requiereVueloComercial,
                lugarMovilizacionId: props.ubicacionData.lugarMovilizacionId,
                estado: props.ubicacionData.estado,
                usuarioRegistra: props.ubicacionData.usuarioRegistra
            })
        }
    }, [props.isOpen])

    useEffect(() => {
        const check = required.every((field) => {
            const value = command[field];
            return value !== null && value !== undefined && value !== "";
        });
        setDisableForm(!check)
    }, [command])

    return { command, setCommand, putEditarUbicacion, loading, setLoading, reset, mensaje, setMensaje, status, disableForm }
}

export { UseUbicacionEditar }